import { render } from "./AddVerticalFeed.vue?vue&type=template&id=96fbc126"
import script from "./AddVerticalFeed.vue?vue&type=script&lang=js"
export * from "./AddVerticalFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__